<template>
  <v-card-text :class="$vuetify.breakpoint.smAndUp ? 'pt-0 pb-2' : ''">
    <v-row no-gutters>
      <v-col cols="12">
        <v-row no-gutters>
          <v-col :class="$vuetify.breakpoint.xsOnly ? 'pt-1' : 'pr-2'" cols="11" md="3" order="0" sm="4">
            <v-row align="center" class="fill-height" justify="start" no-gutters>
              <div class="font-weight-bold black--text sub-sub-category-title my-sm-3">
                {{ subSubCategory.nameText }}
              </div>
            </v-row>
          </v-col>
          <v-col :class="$vuetify.breakpoint.xsOnly ? 'pt-0' : ''" cols="12" md="8" order="1" order-sm="0" sm="7">
            <v-row align="center" class="fill-height" no-gutters>
              <report-personnel-vs-management-chart
                :category="category"
                :loading="loading"
                :name="subSubCategory && subSubCategory.engineName"
                :scale="scale"
                :subcategory="subcategory"
                :surveys="surveys"
              />
            </v-row>
          </v-col>
          <v-col cols="1" order="0" order-sm="1">
            <v-row align="center" class="fill-height" justify="end" no-gutters>
              <drop-down-menu :list-items="dropDownMenuItems" :small="$vuetify.breakpoint.mdAndDown" cols="1"/>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!--<v-col cols="1">
        <v-row align="center" class="fill-height" justify="space-around" no-gutters>
          <v-btn class="ml-3" icon>
            <v-icon>mdi mdi-dots-vertical</v-icon>
          </v-btn>
        </v-row>
      </v-col>-->
    </v-row>
    <div
      v-if="subSubCategorySwot || valueDifference > 40 || (managementStandardDeviation && managementStandardDeviation.type)"
      class="pt-2 pb-2"
    >
      <div v-if="subSubCategorySwot" class="text-caption text-lg-body-2" no-gutters>
        <strong :class="$textColorByType(subSubCategorySwot.type)">
          {{ $tc(`reports.swot_types.${subSubCategorySwot.type}`, 1) }}: </strong>
        {{ subSubCategorySwot.text }}
        <span class="font-italic font-weight-bold"> - {{
            $t(`reports.swot_types_guide.${subSubCategorySwot.type}`)
          }} </span>
      </div>
      <div v-if="valueDifference > 40" class="text-caption text-lg-body-2" no-gutters>
        <strong :class="$textColorByType('weakness')"> {{ $tc(`reports.swot_types.weakness`, 1) }}: </strong>
        {{ $t('reports.personnel_and_management_difference_too_high') }}
        <span class="font-italic font-weight-bold">- {{ $t(`reports.swot_types_guide.weakness`) }}</span>
      </div>
      <div v-if="managementStandardDeviation && managementStandardDeviation.type" class="text-caption text-lg-body-2"
           no-gutters>
        <strong :class="$textColorByType(managementStandardDeviation.type)">
          {{ $tc(`reports.swot_types.${managementStandardDeviation.type}`, 1) }}:
        </strong>
        {{
          $t(`reports.standard_deviations.${managementStandardDeviation.type}`, {value: managementStandardDeviation.value})
        }}
      </div>
      <div v-if="category === 'efficiency' || category === 'capability'">
        <strong>{{ $t('reports.management_tool.title') }}:</strong>
        {{ $t('reports.management_tool.' + subSubCategory.engineName) }}
      </div>
    </div>
    <tasks-modal v-model="showTasks" :category="subSubCategory"/>
  </v-card-text>
</template>

<script>
import params from '@/parameters';
import ReportPersonnelVsManagementChart from '@/components/Tenant/ReportCategory/ReportPersonnelVsManagementChart';
import DropDownMenu from '@/components/DropDownMenu';
import TasksModal from '@/components/Tenant/Tasks/TasksModal';

export default {
  name: 'ReportPersonnelVsManagement',
  components: {TasksModal, DropDownMenu, ReportPersonnelVsManagementChart},
  props: {
    name: {
      type: String,
      required: false,
    },
    category: {
      type: String,
      required: false,
    },
    surveys: {
      type: Array,
      required: false,
    },
    scale: {
      type: Array,
      default: () => [40, 60],
    },
    subcategory: {
      type: Object,
      required: false,
    },
    subSubCategory: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTasks: false,
    };
  },
  computed: {
    dropDownMenuItems() {
      return [
        {
          title: this.$t('reports.category_tasks', {name: this.subSubCategory.nameText}),
          icon: 'mdi mdi-format-list-checks',
          /*route: {
            name: 'tenant_tasks',
            params: {category: this.subSubCategory.id}
          }*/
          action: () => {
            this.showTasks = true;
          },
        },
        {
          title: this.$t('reports.category_history', {name: this.subSubCategory.nameText}),
          icon: 'mdi mdi-history' /*, todo action: something */,
        },
      ];
    },
    valueDifference() {
      if (this.managementValue > -1 && this.personnelValue > -1) {
        return Math.abs(this.managementValue - this.personnelValue);
      }
      return 0;
    },
    mappedSwots() {
      return params.mappedSwots;
    },
    subSubCategorySwot() {
      const swotIndex = this.swots.findIndex(
        swot => swot.key === this.mappedSwots[this.category][this.subcategory?.engineName][this.subSubCategory?.engineName]
      );
      if (swotIndex > -1) {
        return this.swots[swotIndex];
      }
      return false;
    },
    swots() {
      const answer = this.personnelSurvey?.calculation?.engineResponse?.lta?.[this.category]?.avg?.find(value => value.name === this.subcategory.engineName)?.subdata?.find(value => value.name === this.name);

      if (!answer) return [];

      const answerType = answer.value <= this.scale[0] ? 'weakness' : answer.value <= this.scale[1] ? 'opportunity' : 'strength';
      const key = this.mappedSwots[this.category][this.subcategory.engineName][answer.name];
      return [{
        key: key,
        type: answerType,
        text: this.$te(`reports.question_swot.${key}.${answerType}`)
          ? this.$t(`reports.question_swot.${key}.${answerType}`)
          : null,
      }];

    },
    swotTypes() {
      return new Set(this.swots?.map(a => a.type));
    },
    personnelSurvey() {
      return this.surveys?.find(s => s.type === 'PERSONNEL');
    },
    managementSurvey() {
      return this.surveys?.find(s => s.type === 'MANAGEMENT');
    },
    isSubcategory() {
      return !!this.subcategory;
    },
    personnelValue() {
      if (!this.personnelSurvey) return -1;
      let value;
      if (this.isSubcategory) {
        value = this.personnelSurvey?.calculation?.engineResponse?.lta?.[this.category]?.avg
          ?.find(avg => avg.name === this.subcategory?.engineName)
          ?.subdata?.find(d => d.name === this.name)?.value;
      } else {
        value = this.personnelSurvey?.calculation?.engineResponse?.lta?.[this.category]?.avg?.find(avg => avg.name === this.name)?.value;
      }
      if (isNaN(value)) return -1;
      return parseFloat(parseFloat(value).toFixed(0));
    },
    managementValue() {
      if (!this.managementSurvey) return -1;
      let value;
      if (this.isSubcategory) {
        value = this.managementSurvey?.calculation?.engineResponse?.oja?.[this.category]?.avg
          ?.find(avg => avg.name === this.subcategory?.engineName)
          ?.subdata?.find(d => d.name === this.name)?.value;
      } else {
        value = this.managementSurvey?.calculation?.engineResponse?.oja?.[this.category]?.avg?.find(avg => avg.name === this.name)?.value;
      }
      if (isNaN(value)) return -1;
      return parseFloat(parseFloat(value).toFixed(0));
    },
    managementStandardDeviation() {
      if (!this.personnelSurvey) return -1;
      let value;
      if (this.isSubcategory) {
        value = this.managementSurvey?.calculation?.engineResponse?.oja?.[this.category]?.stddev
          ?.find(stddev => stddev.name === this.subcategory?.engineName)
          ?.subdata?.find(d => d.name === this.name);
      } else {
        value = this.managementSurvey?.calculation?.engineResponse?.oja?.[this.category]?.stddev?.find(stddev => stddev.name === this.name);
      }
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-sub-category-title {
  font-size: 0.775rem !important;
  line-height: 0.875rem;
  letter-spacing: 0 !important;
}

@media screen and (min-width: 1300px) {
  .sub-sub-category-title {
    font-size: 0.825rem !important;
    line-height: 0.975rem;
  }
}

@media screen and (min-width: 2250px) {
  .sub-sub-category-title {
    font-size: 1rem !important;
    line-height: 1.225rem;
  }
}
</style>
